/** @format */

import { Loader2 } from "lucide-react";
import { useGlobalLoading } from "../hooks/useGlobalLoading";

/**
 * Full-screen overlay shown when any global loading state is active.
 * Blocks interaction and shows a spinner.
 */
export default function GlobalLoadingOverlay() {
  const active = useGlobalLoading();

  if (!active) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading"
      style={{ pointerEvents: "auto" }}
    >
      <div className="flex flex-col items-center gap-3 rounded-xl bg-slate-900/95 px-6 py-5 shadow-xl ring-1 ring-white/10">
        <Loader2
          className="h-10 w-10 animate-spin text-slate-300"
          aria-hidden
        />
        <span className="text-sm font-medium text-slate-300">Loading…</span>
      </div>
    </div>
  );
}
